import { render, staticRenderFns } from "./EditAttribute.vue?vue&type=template&id=7b485577&scoped=true&"
import script from "./EditAttribute.vue?vue&type=script&lang=js&"
export * from "./EditAttribute.vue?vue&type=script&lang=js&"
import style0 from "./EditAttribute.vue?vue&type=style&index=0&id=7b485577&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b485577",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b485577')) {
      api.createRecord('7b485577', component.options)
    } else {
      api.reload('7b485577', component.options)
    }
    module.hot.accept("./EditAttribute.vue?vue&type=template&id=7b485577&scoped=true&", function () {
      api.rerender('7b485577', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/attributes/EditAttribute.vue"
export default component.exports